import { Icon, styled, StyledSystem } from '@project44/manifest-ui-deprecated';

const IconWrapper = styled(Icon)(() => ({
  width: '16px',
  height: '16px',
  fill: 'none',
}));

function PredictionIcon({ sx }: { sx?: StyledSystem.SystemStyleObject }) {
  return (
    <IconWrapper
      data-testid="prediction-icon"
      sx={{ ...sx }}
      viewBox="0 0 18 18"
    >
      <path
        d="M12.6667 6.00033L13.5 4.16699L15.3333 3.33366L13.5 2.50033L12.6667 0.666992L11.8333 2.50033L10 3.33366L11.8333 4.16699L12.6667 6.00033ZM7.66667 6.33366L6 2.66699L4.33334 6.33366L0.666672 8.00033L4.33334 9.66699L6 13.3337L7.66667 9.66699L11.3333 8.00033L7.66667 6.33366ZM12.6667 10.0003L11.8333 11.8337L10 12.667L11.8333 13.5003L12.6667 15.3337L13.5 13.5003L15.3333 12.667L13.5 11.8337L12.6667 10.0003Z"
        fill="#7300D3"
      />
    </IconWrapper>
  );
}

export default PredictionIcon;
